import React from 'react';
import Title from "../components/typography/Title";

import iconVC from "../images/icons/socials/vc.svg";
import iconTG from "../images/icons/socials/telegram.svg";

const SocialsBlog = ({ title }) => {
    return (
        <div className="blockSocials">
            <Title className="Block-Title" color="black" level="h2" headerStyleNumb="15">{title}</Title>
            <div className="listSocials">
                <a href="https://vc.ru/bank_131" target="_blank" rel="noreferrer"><img src={iconVC} alt=""/>&#8203;</a>
                <a href="https://t.me/bank131" target="_blank" rel="noreferrer"><img src={iconTG} alt=""/>&#8203;</a>
            </div>
        </div>
    )
};

export default SocialsBlog;
